import AvisoModal from 'components/AvisoModal';
import styles from './DeletePropertyModal.module.css';

// AUD-05: borrar una propiedad ahora borra en cascada sus asambleas (y todo
// lo que cuelga de ellas — preguntas, asistencias, votos), además de torres/
// unidades/administradores que ya cascadeaban antes. Un window.confirm()
// genérico ya no comunica lo que realmente se pierde.
export default function DeletePropertyModal({ property, onClose, onConfirm, deleting, error }) {
  const buildingCount = property.buildings?.length || 0;
  const unitCount = property.buildings?.reduce((s, b) => s + (b.units?.length || 0), 0) || 0;
  return (
    <div className="modal-overlay" onClick={deleting ? undefined : onClose}>
      <div className={`modal ${styles.modalBorrar}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3><i className={`fas fa-triangle-exclamation ${styles.iconoTitulo}`} />Eliminar propiedad</h3>
          <button className="btn-close" onClick={onClose} disabled={deleting}>✕</button>
        </div>
        <div className="modal-body">
          {error && <AvisoModal>{error}</AvisoModal>}
          <p>
            Estás a punto de eliminar <strong>{property.name}</strong>.
            Esta acción <strong>no se puede deshacer</strong> y borrará también:
          </p>
          <ul className={styles.lista}>
            <li>{buildingCount} {buildingCount === 1 ? 'torre' : 'torres'} y {unitCount} {unitCount === 1 ? 'unidad' : 'unidades'}</li>
            <li>Todas las asambleas de esta propiedad, junto con sus preguntas, asistencias y votos</li>
            <li>Los administradores asignados a esta propiedad (pierden el acceso; sus cuentas de usuario no se eliminan)</li>
          </ul>
          <p className={styles.nota}>
            Los propietarios (dueños de las unidades) no se eliminan como personas — solo pierden la
            asignación a las unidades de esta propiedad.
          </p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose} disabled={deleting}>Cancelar</button>
          <button className="btn btn-danger" onClick={onConfirm} disabled={deleting}>
            {deleting
              ? <><i className="fas fa-spinner fa-spin" /> Eliminando...</>
              : <><i className="fas fa-trash" /> Sí, eliminar</>}
          </button>
        </div>
      </div>
    </div>
  );
}
